import { render, staticRenderFns } from "./packageAdd.vue?vue&type=template&id=0a9d3552&scoped=true"
import script from "./packageAdd.vue?vue&type=script&lang=js"
export * from "./packageAdd.vue?vue&type=script&lang=js"
import style0 from "./packageAdd.vue?vue&type=style&index=0&id=0a9d3552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9d3552",
  null
  
)

export default component.exports